import React, { useContext, useEffect } from "react";
import { withRouter } from "react-router";
import { Route, Redirect } from "react-router-dom";
import AuthContext from "../../context/authentication/authContext";
import PortalContext from "../../context/portal/portalContext";

const PrivateRoute = ({ component: Component, ...props }) => {
  const authContext = useContext(AuthContext);
  const portalContext = useContext(PortalContext);
  const { authenticated, loading, authenticatedUser, setAuthenticated } = authContext;
  const { sessionExpired } = portalContext;

  useEffect(() => {
    authenticatedUser();
  }, []);

  if(sessionExpired){
    setAuthenticated();
  }

  return (
    <Route
      {...props}
      render={(props) =>
        !authenticated && !loading && sessionExpired ? (
          <Redirect to="/" />
        ) : (
          <Component {...props} />
        )
      }
    />
  );
};

export default withRouter(PrivateRoute);
